import { casinoService } from '@/services'
import { createMutationMixin, toast } from '@/shared'
import useQuery from 'codefabrik-gui-vue/src/apollo/mixins/useQuery'

export function useGetOpenGameRounds () {
  return {
    data () {
      return {
        openGameRounds: [],
        openGameRoundsMeta: {
          loading: false
        }
      }
    },
    methods: {
      getOpenGameRounds (input) {
        this.openGameRoundsMeta.loading = true
        casinoService.getOpenGameRounds(input)
          .then(({ data, errors }) => {
            if (errors) {
              toast.showErrorToast(errors[0].message)
            } else {
              this.openGameRounds = data.openGameRounds
            }
          })
          .finally(() => this.openGameRoundsMeta.loading = false)
      }
    },
  }
}

export function useOpenGameRound () {
  return {
    mixins: [
      useQuery({
        name: 'openGameRound',
        serviceFn: casinoService.getOpenGameRound,
        variables () {
          return {
            gameRoundId: this.$route.params.openGameRoundId,
            casinoId: this.$route.params.casinoId,
          }
        }
      })
    ]
  }
}

export const useRefundOpenGameRound = () => createMutationMixin({
  name: 'refundOpenGameRound',
  service: [casinoService.refundOpenGameRound, 'support.refundSuccess'],
  mapInput (input) {
    return {
      casinoId: this.$route.params.casinoId,
      gameRoundId: this.$route.params.openGameRoundId,
    }
  },
  onSuccess (response, input) {
    this.$router.push({ name: 'open-game-round-list' })
  },
})
